module.exports = __webpack_public_path__ + "@/assets/img/dashboard-due-alert1.f67c325b.png";